export default __webpack_public_path__ + "static/media/icon-dinersclub.e04c108c9a3e4e9f6857ea99c5237554.svg";